import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiClient } from '@offertify/api-client';
import toast from 'react-hot-toast';
import { usePermissions } from '../hooks/usePermissions';

export default function FilialeSelector({ value, onChange, allowCreate = false }: { value: string; onChange: (value: string) => void; allowCreate?: boolean }) {
  const cache = useQueryClient();
  const { hasPermission } = usePermissions();
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);
  const { data: filiali, isError } = useQuery({ queryKey: ['filiali'], queryFn: async () => (await getApiClient().client.get<{ id: string; nome: string }[]>('/filiali')).data });
  const create = useMutation({ mutationFn: async () => (await getApiClient().client.post<{ id: string }>('/filiali', { nome: name.trim() })).data,
    onSuccess: (filiale) => { cache.invalidateQueries({ queryKey: ['filiali'] }); onChange(filiale.id); setCreating(false); setName(''); },
    onError: (error: any) => toast.error(error.response?.data?.detail || 'Errore nella creazione della filiale') });
  return <div className="space-y-2">
    <label className="block text-sm font-medium text-gray-700">Filiale
      <select value={value} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full rounded-lg border border-gray-300 p-2">
        <option value="">Nessuna filiale</option>
        {(filiali || []).map((filiale) => <option key={filiale.id} value={filiale.id}>{filiale.nome}</option>)}
      </select>
    </label>
    {isError && <p className="text-xs text-red-600">Impossibile caricare le filiali.</p>}
    {allowCreate && hasPermission('users:edit') && (creating ? <div className="flex gap-2">
      <input aria-label="Nome nuova filiale" value={name} onChange={(e) => setName(e.target.value)} className="min-w-0 flex-1 rounded-lg border p-2" />
      <button type="button" disabled={!name.trim() || create.isPending} onClick={() => create.mutate()} className="text-sm text-blue-600">Crea</button>
      <button type="button" onClick={() => setCreating(false)} className="text-sm">Annulla</button>
    </div> : <button type="button" onClick={() => setCreating(true)} className="text-sm text-blue-600">Nuova filiale</button>)}
  </div>;
}
